{
  "version": "2.0.4",
  "buildDate": "2026-08-19"
}
